import Cookies from "js-cookie";
const sysNameKey = "sysname";
const state = {
  sidebar: {
    opened: Cookies.get("sidebarStatus")
      ? !!+Cookies.get("sidebarStatus")
      : true,
    withoutAnimation: false,
  },
  device: "desktop",
  sysName:Cookies.get(sysNameKey)==undefined?'':Cookies.get(sysNameKey),
  authorStat:{
    tgzGj:0,
    yslGj:0,
    ytgGj:0,
    dzfBmf:0,
    dzgGj:0,
    dxgGj:0,
    dszFp:0,
    dtk:0,
    ysqTk:0,
    bjTk:0,
  },
  editorStat:{
    gjc:0,
    dpsGj:0,
    ddjBmfGj:0,
    dzfBmfGj:0,
    dzjpsGj:0
  },
  expertStat:{
    gjc:0,
    dpsGj:0,
    ypsGj:0,
  },
  financeStat:{
    skCount:0,
    dtkCount:0,
    dkfpCount:0,
    kjfpzCount:0,
    tkCgCount:0,
    tkSbCount:0,
    jjtkCount:0,
  },
  recheckStat:{
    dczGj:0,
  },
};

const mutations = {
  SET_SYSNAME: (state, name) => {
    state.sysName = name;
    Cookies.set(sysNameKey, name);
  },
  TOGGLE_SIDEBAR: (state) => {
    state.sidebar.opened = !state.sidebar.opened;
    state.sidebar.withoutAnimation = false;
    if (state.sidebar.opened) {
      console.log('1');
      Cookies.set("sidebarStatus", 1);
    } else {
      console.log('0');
      Cookies.set("sidebarStatus", 0);
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set("sidebarStatus", 0);
    state.sidebar.opened = false;
    state.sidebar.withoutAnimation = withoutAnimation;
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device;
  },


  SET_EDITORSTAT: (state, stat) => {
    state.editorStat = stat;
  },

  SET_FINANCESTAT: (state, stat) => {
    state.financeStat = stat;
  },
  SET_AUTHORSTAT: (state, stat) => {
    state.authorStat = stat;
  },
  SET_EXPERTSTAT: (state, stat) => {
    state.expertStat = stat;
  },
  SET_RECHECKSTAT: (state, stat) => {
    state.recheckStat = stat;
  },
};

const actions = {
 /*  setSysName: (context) => {
    //commit("SET_TOKEN", data.token);
    context.commit("SET_SYSNAME");
  }, */
  toggleSideBar({ commit }) {
    commit("TOGGLE_SIDEBAR");
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit("CLOSE_SIDEBAR", withoutAnimation);
  },
  toggleDevice({ commit }, device) {
    commit("TOGGLE_DEVICE", device);
  },

  setFinanceStat({ commit }, stat) {
    commit("SET_FINANCESTAT", stat);
  },
  setAuthorStat({ commit }, stat) {
    commit("SET_AUTHORSTAT", stat);
  },
  setEditorStat({ commit }, stat) {
    commit("SET_EDITORSTAT", stat);
  },
  setExpertStat({ commit }, stat) {
    commit("SET_EXPERTSTAT", stat);
  },
  setRecheckStat({ commit }, stat) {
    commit("SET_RECHECKSTAT", stat);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
